import React from "react";

function ClubInfo({ team }) {
  return (
    <div className="flex-column club-info-wrap">
            <div className="club-badge-wrap">
              <img
                className="club-badge"
                src={`https://media.api-sports.io/football/teams/${team.id}.png`}
              />
            </div>
            <span className="info">{team.name}</span>
          </div>
  );
}

export default ClubInfo;
